import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UserDTO } from '../../../models/DTO/user/user';


@Injectable({
  providedIn: 'root'
})
export class LoggedUserService {


  constructor() { }

  private defaultUser : UserDTO = { } as any;

  private _userInfo = new BehaviorSubject<UserDTO>(this.defaultUser);

  public readonly userInfo$ = this._userInfo.asObservable();

  get userInfo() {
    return this._userInfo.getValue();
  }

  set userInfo(value: UserDTO) {
    this._userInfo.next(value);
  }

  addNewUser(value: UserDTO) {
    this.userInfo = {...value};
  } 

  removeUser() {
    this.userInfo = this.defaultUser;
  }
}